import DetailSectionLayout from "./DetailSectionLayout";
export default DetailSectionLayout;
